var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgBackgroundDocument = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeWidth: 1.5,
    d: "M15.87 77.75v-.153h-.75c-2.95 0-5.37-2.423-5.37-5.385V23.135c0-2.962 2.42-5.385 5.37-5.385h56.76c2.95 0 5.37 2.423 5.37 5.385v49.23c0 2.962-2.42 5.385-5.37 5.385H15.87Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-90)",
    d: "M17.25 27.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM24.75 27.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM32.25 27.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM39.75 27.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM47.25 27.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM54.75 27.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM62.25 27.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM69.75 27.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM17.25 35a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM24.75 35a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM32.25 35a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM17.25 42.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM24.75 42.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM32.25 42.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM17.25 50a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM24.75 50a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM32.25 50a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM17.25 57.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM24.75 57.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM32.25 57.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM17.25 65a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM24.75 65a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM32.25 65a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM17.25 72.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM24.75 72.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM32.25 72.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM47.25 72.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM39.75 72.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM54.75 72.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM62.25 72.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM69.75 72.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z"
  }), React.createElement("path", {
    fill: color,
    d: "M87 34.1v27.3c0 1.95-1.64 3.6-3.578 3.6H41.078c-1.938 0-3.578-1.65-3.578-3.6V34.1c0-1.95 1.64-3.6 3.578-3.6h42.344C85.36 30.5 87 32.15 87 34.1Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M51.375 47a4.125 4.125 0 1 0 0-8.25 4.125 4.125 0 0 0 0 8.25ZM44.25 56v-1.703c0-1.986 1.454-3.547 3.199-3.547h7.852c1.745 0 3.2 1.56 3.2 3.547V56"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M66 43.1h11.55M66 47.75h15M66 52.4h6.9"
  }));
};
export default SvgBackgroundDocument;